import { HarnessCase } from '@camelot/testing-harness';
import { CalendarCase } from './calendar/calendar.case';
import { ChartsCase } from './charts/charts.case';
import { CmsCase } from './cms/cms.case';
import { CoreCommunicationCase } from './core/core-communication.case';
import { CoreCommunicationMessagesCase } from './core/core-communication-messages.case';
import { CoreGridAdvancedCase } from './core/core-grid-advanced.case';
import { CoreGridCase } from './core/core-grid.case';
import { CoreHandlerCase } from './core/core-handler.case';
import { CoreModalsCase } from './core/core-modals.case';
import { CoreRootCase } from './core/core-root.case';
import { FilesViewersCase } from './files/files-viewers.case';
import { FormExtraCase } from './form/form-extra.case';
import { PlanningCase } from './planning/planning.case';
import { PlanningFormsCase } from './planning/planning-forms.case';
import { ProjectCase } from './project/project.case';
import { FilesBasicCase } from './files/files-basic.case';
import { FilesExtendedCase } from './files/files-extended.case';
import { FilesModalCase } from './files/files-modal.case';
import { FormBasicCase } from './form/form-basic.case';
import { FormInputsBackendCase } from './form/form-inputs-backend.case';
import { FormInputsBasicCase } from './form/form-inputs-basic.case';
import { FormInputsMediaCase } from './form/form-inputs-media.case';
import { FormInputsSelectCase } from './form/form-inputs-select.case';
import { FormInteractionsCase } from './interactions/form-interactions.case';
import { CacheReactivityCase } from './interactions/cache-reactivity.case';
import { ErrorFlowsCase } from './interactions/error-flows.case';
import { FilesBehaviorCase } from './interactions/files-behavior.case';
import { FormAdvancedCase } from './interactions/form-advanced.case';
import { FormValidationCase } from './interactions/form-validation.case';
import { GridBehaviorCase } from './interactions/grid-behavior.case';
import { NavMenuCase } from './interactions/nav-menu.case';
import { StateFlowsCase } from './interactions/state-flows.case';
import { UploadFilesCase } from './interactions/upload-files.case';
import { MiscBehaviorsCase } from './interactions/misc-behaviors.case';
import { NotificationFlowsCase } from './interactions/notification-flows.case';
import { IconsCase } from './icons/icons.case';
import { UiInteractionsCase } from './interactions/ui-interactions.case';
import { MenuCase } from './menu/menu.case';
import { NotificationCase } from './notification/notification.case';
import { NotificationTemplatesCase } from './notification/notification-templates.case';
import { SmokeCase } from './smoke.case';
import { UiButtonsCase } from './ui/ui-buttons.case';
import { UiCardsCase } from './ui/ui-cards.case';
import { UiContainersCase } from './ui/ui-containers.case';
import { UiEnumsCase } from './ui/ui-enums.case';
import { UiInfoCase } from './ui/ui-info.case';
import { UiLayoutCase } from './ui/ui-layout.case';
import { UiListsCase } from './ui/ui-lists.case';
import { UiMiscCase } from './ui/ui-misc.case';
import { UiModalCase } from './ui/ui-modal.case';
import { UiOverlayCase } from './ui/ui-overlay.case';
import { UiPeopleCase } from './ui/ui-people.case';
import { UiSwiperCase } from './ui/ui-swiper.case';
import { UiTextCase } from './ui/ui-text.case';
import { UserCase } from './user/user.case';
import { UtilsCase } from './utils/utils.case';
import { WysiswygCase } from './wysiswyg/wysiswyg.case';

export const E2E_CASES: HarnessCase[] = [
  { component: CalendarCase, id: 'calendar' },
  { component: ChartsCase, id: 'charts' },
  { component: CmsCase, id: 'cms' },
  { component: CoreCommunicationCase, id: 'core-communication' },
  { component: CoreCommunicationMessagesCase, id: 'core-communication-messages' },
  { component: CoreGridAdvancedCase, id: 'core-grid-advanced' },
  { component: CoreGridCase, id: 'core-grid' },
  { component: CoreHandlerCase, id: 'core-handler' },
  { component: CoreModalsCase, id: 'core-modals' },
  { component: CoreRootCase, id: 'core-root' },
  { component: FilesViewersCase, id: 'files-viewers' },
  { component: FormExtraCase, id: 'form-extra' },
  { component: PlanningFormsCase, id: 'planning-forms' },
  { component: PlanningCase, id: 'planning' },
  { component: ProjectCase, id: 'project' },
  { component: FilesBasicCase, id: 'files-basic' },
  { component: FilesExtendedCase, id: 'files-extended' },
  { component: FilesModalCase, id: 'files-modal' },
  { component: FormBasicCase, id: 'form-basic' },
  { component: FormInputsBackendCase, id: 'form-inputs-backend' },
  { component: FormInputsBasicCase, id: 'form-inputs-basic' },
  { component: FormInputsMediaCase, id: 'form-inputs-media' },
  { component: FormInputsSelectCase, id: 'form-inputs-select' },
  { component: FormInteractionsCase, id: 'form-interactions' },
  { component: CacheReactivityCase, id: 'cache-reactivity' },
  { component: ErrorFlowsCase, id: 'error-flows' },
  { component: FilesBehaviorCase, id: 'files-behavior' },
  { component: FormAdvancedCase, id: 'form-advanced' },
  { component: FormValidationCase, id: 'form-validation' },
  { component: GridBehaviorCase, id: 'grid-behavior' },
  { component: NavMenuCase, id: 'nav-menu' },
  { component: StateFlowsCase, id: 'state-flows' },
  { component: UploadFilesCase, id: 'upload-files' },
  { component: MiscBehaviorsCase, id: 'misc-behaviors' },
  { component: NotificationFlowsCase, id: 'notification-flows' },
  { component: IconsCase, id: 'icons' },
  { component: MenuCase, id: 'menu' },
  { component: NotificationCase, id: 'notification' },
  { component: NotificationTemplatesCase, id: 'notification-templates' },
  { component: SmokeCase, id: 'smoke' },
  { component: UiButtonsCase, id: 'ui-buttons' },
  { component: UiCardsCase, id: 'ui-cards' },
  { component: UiContainersCase, id: 'ui-containers' },
  { component: UiEnumsCase, id: 'ui-enums' },
  { component: UiInteractionsCase, id: 'ui-interactions' },
  { component: UiInfoCase, id: 'ui-info' },
  { component: UiLayoutCase, id: 'ui-layout' },
  { component: UiListsCase, id: 'ui-lists' },
  { component: UiMiscCase, id: 'ui-misc' },
  { component: UiModalCase, id: 'ui-modal' },
  { component: UiOverlayCase, id: 'ui-overlay' },
  { component: UiPeopleCase, id: 'ui-people' },
  { component: UiSwiperCase, id: 'ui-swiper' },
  { component: UiTextCase, id: 'ui-text' },
  { component: UserCase, id: 'user' },
  { component: UtilsCase, id: 'utils' },
  { component: WysiswygCase, id: 'wysiswyg' },
];
